var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.isVideoProcessing)?_c('div',{staticClass:"article-edit-page"},[(_vm.article)?_c('article-editor'):_vm._e()],1):_c('upload-record-status')
}
var staticRenderFns = []

export { render, staticRenderFns }